import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import styles from "./Interested.module.scss";
import _ from "lodash";
import Image from "@components/Image";
import Divider from "@components/Divider";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StoryCategoryService/getter";
import { useRouteContext } from "@providers/RouteProvider";
import Swiper from "@components/Swiper";
import useSwiper from "@hooks/useSwiper";
const View = ({}: any) => {
  const { i18n } = useTranslationContext();
  const { categories } = usePageContext();
  const { router } = useRouteContext();
  const data = _.map(categories, (item) => ({
    title: getter.name(item),
    slug: getter.slug(item),
    image: getter.image(item),
  }));
  const handler = {
    onClick: (slug: string) => {
      router.push("storiesCategory", { slug });
    },
  };
  useSwiper(".swiper-story", {
    // rewind: true,
    spaceBetween: 32,
    speed: 1000,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1280: {
        slidesPerView: 4.5,
      },
    },
    // navigation: {
    //   nextEl: ".swiper-arrow-next-dinning-experiencing",
    //   prevEl: ".swiper-arrow-prev-dinning-experiencing",
    // },
  });
  // const data = [
  //   { title: "Art & Culture", src: "/story/1.jpg" },
  //   { title: "Live like a local", src: "/story/2.jpg" },
  //   { title: "Sustainability", src: "/story/3.jpg" },
  //   { title: "What’s on", src: "/story/4.jpg" },
  // ];
  //   const lists = _.chunk(data, _.round(data.length / 2));
  return (
    <section data-scroll-section className={cx(styles.section)}>
      <div className="inner">
        <Divider
          label={
            <span className="text-c-1">{i18n.t("Stories.interested")}</span>
          }
        />
      </div>
      {/* <div className={cx("inner", styles.box)}> */}
      <Swiper className={cx("inner swiper-story", styles.box)}>
        {_.map(data, (item, index) => {
          return (
            <div
              className={cx("swiper-slide", styles.item)}
              key={`interested_${index}`}
              onClick={() => handler.onClick(item.slug)}
            >
              <Image
                wrapperProps={{ className: styles.image }}
                scale={1.3}
                src={_.get(item, "image.src")}
                alt={_.get(item, "image.alt")}
              />
              <div className={cx("ama-sub-title", styles.title)}>
                {item.title}
              </div>
            </div>
          );
        })}
      </Swiper>
      {/* </div> */}
    </section>
  );
};
export default View;
